import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { OverChargeClaimDetailed } from '@/views/screens/Claims/types';

export interface GetOCClaimDetailsRequestParams {
  FBOCKey: number;
}

export const getOCClaimDetailsAPI = (params: GetOCClaimDetailsRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.OVERCHARGE_CLAIM}/GetClaim`,
  });
};

export type OCClaimDetailsResponse = OverChargeClaimDetailed;

export const fetchOCClaimDetails = async (params: GetOCClaimDetailsRequestParams): Promise<OCClaimDetailsResponse> => {
  const response: AxiosResponse<OCClaimDetailsResponse> = await getOCClaimDetailsAPI(params);
  return response.data;
};
